module.exports = __webpack_public_path__ + "img/icon-eyeclose.ca51656f.svg";